import { useCallback, useEffect, useState } from "react";
import { getPerpsPositions } from "@/lib/hyperliquid";

interface UsePerpsPositionsReturn {
  data: any | null;
  isLoading: boolean;
  error: string | null;
  refresh: () => Promise<void>;
}

export function usePerpsPositions(address: string | undefined): UsePerpsPositionsReturn {
  const [data, setData] = useState<any | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    if (!address) return;

    setIsLoading(true);
    setError(null);

    try {
      const res = await getPerpsPositions(address);
      setData(res);
    } catch (err) {
      const message = err instanceof Error ? err.message : "Failed to fetch perps positions";
      setError(message);
    } finally {
      setIsLoading(false);
    }
  }, [address]);

  useEffect(() => {
    if (address) {
      refresh();
    }
  }, [address, refresh]);

  return { data, isLoading, error, refresh };
}
